"use strict";
/**
 * @interface ReportExportStatus
 * @description Interface for exporting a report
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_base_1 = __importDefault(require("./api_base"));
exports.default = {
    /**
     * @method create - HTTP Post
     * @return Object - jobId - required for the HTTP get request
     */
    create: function (format, source) {
        // cookies required by backend service `Grover`
        var data = {
            source: source,
            file_name: format
        };
        return api_base_1.default.post("/export_" + format + "_jobs." + format, data).then(function (res) {
            return {
                id: res.data.data.id,
                format: format
            };
        });
    },
    /**
     * @method get - HTTP Get Request
     * @param
     * @return String - URL to generated report
     */
    get: function (_a) {
        var id = _a.id, format = _a.format;
        return api_base_1.default.get("/export_" + format + "_jobs/" + id).then(function (response) { return response.data.data; });
    }
};
//# sourceMappingURL=report_export_status_api.js.map